import React from "react";
import Link from "next/link";
import Icon from "../components/Icon";
import Button from "../components/Button";
import renderIcon from "../../../components/renderIcon";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const styles = `
.t26-donate-strip-wrap {
  padding: clamp(24px, 4vw, 48px) clamp(16px, 4vw, 32px);
  max-width: var(--container);
  margin-inline: auto;
}
.t26-donate-strip {
  position: relative;
  overflow: hidden;
  border-radius: clamp(20px, 2.4vw, 28px);
  padding: clamp(36px, 5vw, 64px) clamp(28px, 4vw, 56px);
  background: linear-gradient(135deg,
    var(--primary) 0%,
    color-mix(in oklab, var(--primary) 65%, var(--secondary)) 100%);
  color: var(--primary-contrast);
  display: grid;
  grid-template-columns: 1fr auto;
  gap: clamp(20px, 3vw, 36px);
  align-items: center;
  isolation: isolate;
}
.t26-donate-strip::before {
  content: "";
  position: absolute; z-index: 0;
  top: -40%; inset-inline-end: -10%;
  width: 480px; height: 480px;
  background: radial-gradient(circle, color-mix(in oklab, var(--secondary) 40%, transparent) 0%, transparent 70%);
  pointer-events: none;
}
.t26-donate-strip__content { position: relative; z-index: 1; }
.t26-donate-strip__eyebrow {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 11px; font-weight: 700;
  letter-spacing: .22em; text-transform: uppercase;
  color: color-mix(in oklab, white 65%, var(--secondary) 35%);
  margin-bottom: 12px;
}
.t26-donate-strip__title {
  font-family: var(--font-display);
  margin: 0;
  font-size: clamp(26px, 3.6vw, 40px);
  font-weight: 700;
  line-height: 1.15;
  text-wrap: balance;
  max-width: 22ch;
}
.t26-donate-strip__title em {
  font-style: italic;
  color: color-mix(in oklab, white 60%, var(--secondary) 40%);
}
.t26-donate-strip__desc {
  margin: 12px 0 0;
  font-size: 15px;
  color: rgba(255,255,255,.82);
  max-width: 56ch;
  text-wrap: pretty;
}
.t26-donate-strip__cta { position: relative; z-index: 1; }
.t26-donate-strip__btn {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 14px 28px;
  background: #fff;
  color: var(--ink) !important;
  border-radius: var(--r-pill);
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  text-decoration: none;
  transition: transform .15s ease, box-shadow .15s ease;
  box-shadow: 0 8px 22px -10px rgba(0,0,0,.3);
}
.t26-donate-strip__btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -10px rgba(0,0,0,.4);
}
/* Le cœur dans le bouton blanc : couleur primary pour rester visible
   (au lieu d'hériter du texte foncé qui se confondait avec le fond). */
.t26-donate-strip__btn svg {
  color: var(--primary);
}

@media (max-width: 720px) {
  .t26-donate-strip { grid-template-columns: 1fr; text-align: center; }
  .t26-donate-strip__title { max-width: 100%; }
}
`;

export default function DonationStrip({ context, eyebrow, title, description, ctaLabel, ctaUrl }) {
    const { org, config } = context;
    if (config["home.sections.disable.don"] === true) return null;

    const finalEyebrow = eyebrow || t`Faire un don`;
    const finalTitle = title || t`Soutenez nos actions au quotidien`;
    const finalDesc = description || t`Votre don, même petit, permet à notre communauté de continuer à grandir`;
    const finalUrl = ctaUrl || `${org.BASE_WEB_URL}/don`;
    const finalLabel = ctaLabel || t`Faire un don`;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <div className="t26-donate-strip-wrap">
                <div className="t26-donate-strip">
                    <div className="t26-donate-strip__content">
                        <span className="t26-donate-strip__eyebrow">
                            <Icon name="heart" size={12} />
                            {finalEyebrow}
                        </span>
                        <h2 className="t26-donate-strip__title">{finalTitle}</h2>
                        <p className="t26-donate-strip__desc">{finalDesc}</p>
                    </div>
                    <div className="t26-donate-strip__cta">
                        <Link href={finalUrl}>
                            <span className="t26-donate-strip__btn">
                                {renderIcon({ name: "IconHeartFilled", source: "tabler" }, 18, "var(--primary)")}
                                {finalLabel}
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
